import { ForwardedRef, HTMLAttributes, forwardRef } from "react";
import { Direction, HorizontalAlign, VerticalAlign } from "..";
import styles from "./styles.module.scss";

export type GridContainerProps = HTMLAttributes<HTMLDivElement> & {
  direction?: Direction,
  verticalAlign?: VerticalAlign,
  horizontalAlign?: HorizontalAlign,
  gap?: number | string,
  rows?: number,
  columns?: number,
};

export type GridContainerRef = ForwardedRef<HTMLDivElement>;

const GridContainer = ({ className, children, direction, horizontalAlign, verticalAlign, gap, rows, columns, style, ...props }: GridContainerProps, ref: GridContainerRef) => {
  if (process.env.NODE_ENV === "development") {
    if (direction === Direction.Column && rows === undefined) {
      console.warn("The \"direction\" property is set to \"column\", so the \"rows\" one should be set too.");
    }
  }

  return (
    <div
      ref={ref}
      className={`${styles.gridContainer} ${styles[direction ?? Direction.Row]} ${styles[horizontalAlign ?? HorizontalAlign.Center]} ${styles[verticalAlign ?? VerticalAlign.Middle]} ${className ?? ""}`}
      style={(gap || rows || columns) ?
        Object.assign({
          gap: gap,
          gridTemplateColumns: columns ? `repeat(${columns}, auto)` : undefined,
          gridTemplateRows: rows ? `repeat(${rows}, auto)` : undefined,
        }, style) :
        style
      }
      {...props}
    >
      {children}
    </div>
  );
};

export default forwardRef(GridContainer);